import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import LayoutMenu from './components/layout/LayoutMenu';

import PgLogin from './pages/PgLogin';
import PgAgenda from './pages/PgAgenda';
import PgClientes from './pages/PgClientes';
import PgClienteEditar from './pages/PgClienteEditar';
import PgItens from './pages/PgItens';
import PgItemEditar from './pages/PgItemEditar';
import PgAgendamentos from './pages/PgAgendamentos';
import PgAgendamentoEditar from './pages/PgAgendamentoEditar';
import PgFaturas from './pages/PgFaturas';
import PgFaturaEditar from './pages/PgFaturaEditar';
import PgPagamentos from './pages/PgPagamentos';
import PgPagamentoEditar from './pages/PgPagamentoEditar';

import PgRelFaturas from './pages/PgRelFaturas';
import PgRelFaturasCanceladas from './pages/PgRelFaturasCanceladas';
import PgRelFinanceiro from './pages/PgRelFinanceiro';
import PgRelFinanceiroExtorno from './pages/PgRelFinanceiroExtorno';
import PgRelAniversario from './pages/PgRelAniversario';
import PgLogs from './pages/PgLogs';

import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import 'react-toastify/dist/ReactToastify.css';
import './css/generic.css';

function App() {
  const [session, setSession] = useState(null);

  const handleLogin = (sessionData) => {
    console.log('Session Data:', sessionData);
    // Salva o token no localStorage
    if (sessionData.token) {
      localStorage.setItem('token', sessionData.token);
    }
    // Salva outras informações da sessão se necessário
    localStorage.setItem('id_cliente', sessionData.id_cliente);
    localStorage.setItem('nome', sessionData.nome);
    localStorage.setItem('email', sessionData.email);
    
    setSession(sessionData);
  };
  return (
    <Router>
      <div>
      <ToastContainer />
      {session ? (
          <>
        <LayoutMenu userId={session?.id_cliente}/>
        <Routes>
          <Route path="/" element={<PgClientes />} />
          <Route path="/agenda" element={<PgAgenda />} />
          <Route path="/clientes" element={<PgClientes />} />
          <Route path="/cliente/novo" element={<PgClienteEditar />} />
          <Route path="/cliente/editar/:id" element={<PgClienteEditar userId={session?.id_cliente} />} />
          <Route path="/itens" element={<PgItens />} />
          <Route path="/item/novo" element={<PgItemEditar />} />
          <Route path="/item/editar/:id" element={<PgItemEditar />} />
          <Route path="/agendamentos" element={<PgAgendamentos />} />
          <Route path="/agendamento/novo" element={<PgAgendamentoEditar />} />
          <Route path="/agendamento/editar/:id" element={<PgAgendamentoEditar />} />
          <Route path="/faturas" element={<PgFaturas />} />
          <Route path="/fatura/novo" element={<PgFaturaEditar />} />
          <Route path="/fatura/editar/:id" element={<PgFaturaEditar />} />
          <Route path="/pagamentos" element={<PgPagamentos />} />
          <Route path="/pagamento/novo" element={<PgPagamentoEditar />} />
          <Route path="/pagamento/editar/:id/:redirectTo?" element={<PgPagamentoEditar />} />
          <Route path="/relatorios/faturas" element={<PgRelFaturas />} />
          <Route path="/relatorios/faturas-canceladas" element={<PgRelFaturasCanceladas />} />
          <Route path="/relatorios/financeiro" element={<PgRelFinanceiro />} />
          <Route path="/relatorios/financeiro-extorno" element={<PgRelFinanceiroExtorno />} />
          <Route path="/relatorios/aniversario" element={<PgRelAniversario />} />
          <Route path="/logs" element={<PgLogs />} />
        </Routes>
        </>
        ) : (
          <PgLogin onLogin={handleLogin} />
        )}
      </div>
    </Router>
  );
}
      

export default App;